import {
  Heart,
  ShieldCheck,
  DoorOpen,
  Car,
  CreditCard,
  Smile,
} from "lucide-react";
import { siteData } from "../data/mock";

const iconMap = {
  heart: Heart,
  shield: ShieldCheck,
  door: DoorOpen,
  car: Car,
  creditCard: CreditCard,
  smile: Smile,
};

export const AmenitiesSection = () => {
  return (
    <section
      id="amenities"
      aria-labelledby="amenities-heading"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left - Amenities */}
          <div>
            <span className="font-mono text-[11px] uppercase tracking-widest text-stone-400 block mb-3">Our Clinic</span>
            <h2
              id="amenities-heading"
              className="text-3xl sm:text-4xl font-semibold text-[#232323] mb-4 tracking-tight"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Amenities & Comfort
            </h2>
            <p className="text-lg text-stone-500 leading-relaxed mb-8">
              We provide a welcoming, comfortable, and inclusive environment for every patient.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {siteData.amenities.map((amenity, index) => {
                const Icon = iconMap[amenity.icon];
                return (
                  <div
                    key={index}
                    className="flex items-center gap-3.5 p-4 bg-[#FFFAF5] rounded-xl border border-stone-100/80 shadow-sm hover:shadow-md hover:border-[#C5D4C0]/50 transition-all duration-200"
                  >
                    <div className="w-9 h-9 rounded-full bg-[#F0F4ED] flex items-center justify-center shrink-0">
                      <Icon
                        className="w-4 h-4 text-[#5E8C61]"
                        aria-hidden="true"
                      />
                    </div>
                    <p className="text-sm text-stone-700 font-medium">
                      {amenity.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right - Insurance */}
          <div>
            <span className="font-mono text-[11px] uppercase tracking-widest text-stone-400 block mb-3">Insurance & Payment</span>
            <h2
              className="text-3xl sm:text-4xl font-semibold text-[#232323] mb-4 tracking-tight"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Insurance Accepted
            </h2>
            <p className="text-lg text-stone-500 leading-relaxed mb-8">
              We accept a variety of insurance plans and offer flexible payment options to make treatment accessible.
            </p>
            <div className="space-y-3">
              {siteData.insurance.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3.5 p-4 bg-[#FFFAF5] rounded-xl border border-stone-100/80 shadow-sm hover:shadow-md hover:border-[#C5D4C0]/50 transition-all duration-200"
                >
                  <div className="w-2 h-2 rounded-full bg-[#BCA182] shrink-0" aria-hidden="true" />
                  <p className="text-sm text-stone-700 font-medium">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
